import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { appConfig } from "../../insaweb.config";

@Injectable()
export class PasswordChangeGuard implements CanActivate {
	constructor(private _router: Router) {}

	canActivate(): boolean {
		const visible =
			(appConfig as any).showPasswordChangeButtonOnLogin === undefined
				? false
				: (appConfig as any).showPasswordChangeButtonOnLogin;
		if (!visible) {
			this._router.navigate(["/login"]);
			return false;
		}
		return true;
	}
}



// WEBPACK FOOTER //
// ./app/insa-services/password-change.guard.ts